"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IndexBasedGridSelection_1 = require("../IndexBasedGridSelection");
var TreeGridSelectionUtils_1 = require("./TreeGridSelectionUtils");
/**
 * TreeGridSelection is used to track the selected items in the grid who are
 * hidden because their parent is in a collapsed state. It inherits from
 * IndexBasedGridSelection, which is used to track the visible selections.
 */
var TreeGridSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TreeGridSelection, _super);
    function TreeGridSelection(rows, cols) {
        var _this = _super.call(this, rows, cols) || this;
        /**
         * When a row is expanded, any hidden selections are pulled from hiddenSelection, converted to grid-based ranges, and
         * pushed onto the regular selection.
         * When a row is collapsed, any selected children of the row are moved from the regular selection to the hidden selection.
         * @param isExpanded - true if the row is being expanded; false if it's being collapsed
         * @param gridRowIndex - the index of the row in the grid
         * @param numChildren - how many children belong to this row
         * @param convertToDomainIndex - method used to convert grid row indexes to domain indexes.
         */
        _this.handleRowExpansion = function (isExpanded, gridRowIndex, numChildren, convertGridRowIndexToDomainIndex) {
            if (numChildren <= 0) {
                return false; // nothing to do if there are no children
            }
            var hiddenDomainRanges = _this.getHiddenSelection().rowRanges;
            var visibleGridRanges = _this.getSelection().rowRanges;
            var selectionIsChanged = false;
            if (isExpanded) {
                TreeGridSelectionUtils_1.TreeGridSelectionUtils.splitRanges(visibleGridRanges, gridRowIndex, gridRowIndex, numChildren);
                var domainIndex = convertGridRowIndexToDomainIndex(gridRowIndex);
                var domainRangeOfChildren = { begin: domainIndex + 1, end: domainIndex + numChildren };
                selectionIsChanged = TreeGridSelectionUtils_1.TreeGridSelectionUtils.unhideDomainSelections(hiddenDomainRanges, visibleGridRanges, gridRowIndex + 1, domainRangeOfChildren);
            }
            else {
                var extractedRanges = TreeGridSelectionUtils_1.TreeGridSelectionUtils.splitRanges(visibleGridRanges, gridRowIndex, gridRowIndex + numChildren, -numChildren);
                selectionIsChanged = extractedRanges.length > 0;
                extractedRanges.forEach(function (range) {
                    hiddenDomainRanges.push({ begin: convertGridRowIndexToDomainIndex(range.begin), end: convertGridRowIndexToDomainIndex(range.end) });
                });
            }
            return selectionIsChanged;
        };
        _this.hiddenSelection = {
            rowRanges: [],
            colRanges: [],
            cellRanges: [],
            gridDimensions: null,
        };
        _this.selectColumnOnHeaderClick = false;
        _this.selectionBehavior = IndexBasedGridSelection_1.SelectionBehavior.SelectRow;
        return _this;
    }
    TreeGridSelection.prototype.clearSelection = function () {
        _super.prototype.clearSelection.call(this);
        this.clearHiddenSelection();
    };
    TreeGridSelection.prototype.initializeSelection = function (selectionData) {
        this.clearHiddenSelection();
        _super.prototype.initializeSelection.call(this, selectionData);
    };
    TreeGridSelection.prototype.initializeHiddenSelection = function (hiddenSelectionData) {
        this.hiddenSelection = hiddenSelectionData;
    };
    TreeGridSelection.prototype.getHiddenSelection = function () {
        return this.hiddenSelection;
    };
    TreeGridSelection.prototype.clearHiddenSelection = function () {
        if (this.hiddenSelection) {
            this.hiddenSelection.rowRanges = [];
            this.hiddenSelection.colRanges = [];
            this.hiddenSelection.cellRanges = [];
        }
    };
    /** @returns a new array containing the indexes of all selected domain items, including those that are
     * hidden because they belong to a parent that is in a collapsed state.
     */
    TreeGridSelection.prototype.getSelectedDomainIndexes = function (convertToDomainIndex) {
        var domainIndexes = [];
        TreeGridSelectionUtils_1.TreeGridSelectionUtils.forEachRowIndexInSelection(this.getSelection(), function (index) { return domainIndexes.push(convertToDomainIndex(index)); });
        TreeGridSelectionUtils_1.TreeGridSelectionUtils.forEachRowIndexInSelection(this.getHiddenSelection(), function (index) { return domainIndexes.push(index); });
        return domainIndexes;
    };
    return TreeGridSelection;
}(IndexBasedGridSelection_1.IndexBasedGridSelection));
exports.TreeGridSelection = TreeGridSelection;
//# sourceMappingURL=TreeGridSelection.js.map